import Id from './Id';
import CreatorUser from './CreatorUser';
import Status from './Status';
import Created from './Created';
import Updated from './Updated';
import Comment from './Comment';
import SerialNumber from './SerialNumber'
import DeliveryDate from './DeliveryDate'

export const labels = {
  Id: 'Id',
  Comment: 'Megjegyzés',
  CreatorUser: 'Rögzítette',
  Status: 'Státusz',
  Created: 'Létrehozva',
  Updated: 'Módosítva',
  SerialNumber: 'Sorszám',
  DeliveryDate: 'Kiállítás dátuma',
};

export const allColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Comment',
}, {
  value: 'CreatorUser',
}, {
  value: 'Updated',
}, {
  value: 'Status',
}, {
  value: 'Created',
}, {
  value: 'SerialNumber',
}];

export const defaultColumns = [{
  value: 'Id',
  fixed: true,
}, {
  value: 'Status',
}, {
  value: 'SerialNumber',
},  {
  value: 'CreatorUser',
},  {
  value: 'DeliveryDate',
}];

export const defaultSort = {
  prop: 'created_at',
  order: 'ascending'
};

export default {
  CreatorUser,
  Updated,
  Created,
  Id,
  Status,
  Comment,
  SerialNumber,
  DeliveryDate,
};
